export enum DistanceUnit {
  CM = 'cm',
  IN = 'in',
  MM = 'mm',
}

export const distanceUnitMap: Record<string, DistanceUnit> = {
  [DistanceUnit.CM]: DistanceUnit.CM,
  [DistanceUnit.IN]: DistanceUnit.IN,
  [DistanceUnit.MM]: DistanceUnit.MM,
};
